export const EMULATED_USER_ID = 'emulated-user-id';
export const USER_PROJECT_ID = 'user-project-id';
